import { render, staticRenderFns } from "./liberacaoautomatica.vue?vue&type=template&id=4354c573&"
import script from "./liberacaoautomatica.vue?vue&type=script&lang=js&"
export * from "./liberacaoautomatica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports